module.exports = __webpack_public_path__ + "img/pencil-outline.c81c01cc.svg";